<template>
  <div class="">
    <Header></Header>

    <!-- Main -->
    <main class="u-main">
      <Navigation></Navigation>

      <div class="u-content">
        <div class="u-body min-h-700">
          <h1 class="h2 mb-2">Sliders</h1>

          <!-- Breadcrumb -->
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'sliders' }">Sliders </router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Edit</li>
            </ol>
          </nav>
          <!-- End Breadcrumb -->

          <form
            @submit.prevent="editRow"
            enctype="multipart/form-data"
            class="h-100"
          >
            <!-- Content -->
            <div class="tab-content">
              <div class="row">
                <!-- ******* Card ******** -->
                <div class="col-md-12 mb-5">
                  <!-- Card Background -->
                  <div class="card">
                    <div class="card-body">
                      <div id="accordion" class="accordion">
                        <div id="TabBackground" class="card-header">
                          <h2
                            class="h4 card-header-title"
                            @click="collapseToggle('Background')"
                            aria-expanded="false"
                            aria-controls="collapseBackground"
                            data-toggle="collapse"
                            data-target="#collapseBackground"
                          >
                            Background
                            <span
                              id="iconToggleBackground"
                              class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black"
                            >
                            </span>
                          </h2>
                        </div>
                        <div
                          id="collapseBackground"
                          class="collapse show"
                          aria-labelledby="TabBackground"
                          data-parent="#accordion"
                        >
                          <div class="col-12 pt-3">
                            <div class="form-group">
                              <label
                                >Image 700 * 600
                                <button
                                  v-if="row.preview_image"
                                  type="button"
                                  class="btn btn-danger btn-sm btn-pill"
                                  style="margin-top: -10px; margin-left: 10px"
                                  @click="
                                    row.preview_image = '';
                                    row.image = '';
                                  "
                                >
                                  Remove Image
                                </button>
                              </label>
                              <p>
                                <img
                                  v-if="row.preview_image"
                                  :src="row.preview_image"
                                  style="max-width: 100%"
                                />
                              </p>
                              <input
                                type="file"
                                class="form-control"
                                v-on:change="onImageChange"
                              />
                            </div>

                            <div class="form-group">
                              <label
                                >Or Video 700 * 600
                                <button
                                  v-if="row.preview_video"
                                  type="button"
                                  class="btn btn-danger btn-sm btn-pill"
                                  style="margin-top: -10px; margin-left: 10px"
                                  @click="
                                    row.preview_video = '';
                                    row.video = '';
                                  "
                                >
                                  Remove Video
                                </button>
                              </label>
                              <p>
                                <iframe
                                  v-if="row.preview_video"
                                  :src="row.preview_video"
                                  style="width: 100%; height: 600px"
                                >
                                </iframe>
                              </p>
                              <input
                                type="file"
                                class="form-control"
                                v-on:change="onVideoChange"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Card Background -->

                  <div class="card mt-5">
                    <div class="card-body">
                      <div id="accordion" class="accordion">
                        <div id="TabContent" class="card-header">
                          <h2
                            class="h4 card-header-title"
                            @click="collapseToggle('Content')"
                            aria-expanded="false"
                            aria-controls="collapseContent"
                            data-toggle="collapse"
                            data-target="#collapseContent"
                          >
                            Content
                            <span
                              id="iconToggleContent"
                              class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black"
                            >
                            </span>
                          </h2>
                        </div>
                        <div
                          id="collapseContent"
                          class="collapse"
                          aria-labelledby="TabContent"
                          data-parent="#accordion"
                        >
                          <div class="col-12 pt-3">
                            <div class="col-12 row">
                              <div class="col-md-6">
                                <label>Background Color</label>
                                <input
                                  type="color"
                                  class="form-control"
                                  v-model="row.bgColor"
                                  style="height: 100px"
                                />
                              </div>
                              <div class="col-md-6">
                                <label>Line Color</label>
                                <input
                                  type="color"
                                  class="form-control"
                                  v-model="row.lineColor"
                                  style="height: 100px"
                                />
                              </div>

                              <div class="form-group col-12">
                                <label>Title</label>
                                <vue-editor
                                  id="input04"
                                  v-model="row.title"
                                  :init="{
                                    height: 250,
                                  }"
                                />
                              </div>

                              <div class="form-group col-12">
                                <label>Description</label>
                                <vue-editor
                                  id="inputd04"
                                  v-model="row.body"
                                  :init="{
                                    height: 250,
                                  }"
                                />
                              </div>
                            </div>

                            <div class="col-12 row">
                              <!-- Sort -->
                              <div class="form-group col-6">
                                <label for="input3">Sort</label>
                                <input
                                  class="form-control"
                                  id="input3"
                                  min="0"
                                  type="number"
                                  v-model.number="row.sort"
                                />
                              </div>
                              <div class="form-group col-6">
                                <label for="input3"
                                  >Duration (per second)</label
                                >
                                <input
                                  class="form-control"
                                  id="input3"
                                  min="1"
                                  type="number"
                                  v-model.number="row.duration"
                                />
                              </div>

                              <div class="form-group col-6">
                                <label for="input3">Button Name</label>
                                <input
                                  class="form-control"
                                  id="input3"
                                  type="text"
                                  v-model="row.button"
                                />
                              </div>
                              <div class="form-group col-6">
                                <label for="input3">Redirect</label>
                                <input
                                  class="form-control"
                                  id="input3"
                                  type="text"
                                  v-model="row.redirect"
                                />
                              </div>
                            </div>

                            <h4><br />Status & Visibility</h4>
                            <div class="col-md-12">
                              <!-- Status -->
                              <div class="form-group">
                                <div class="custom-control custom-switch mb-2">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="customSwitch1"
                                    :checked="row.status"
                                    @click="onStatus"
                                  />
                                  <label
                                    class="custom-control-label"
                                    for="customSwitch1"
                                    v-html="row.status ? 'Active' : 'Inactive'"
                                  >
                                  </label>
                                </div>
                              </div>
                              <!-- End Status -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Card Writer -->
                </div>
                <!-- ******* End Card ******** -->
              </div>
            </div>
            <!-- End Content -->

            <!-- Buttons -->
            <div class="col-md-12 row">
              <div class="form-group mr-2">
                <button class="btn btn-primary" :disabled="btnLoading">
                  <span v-if="btnLoading">
                    <span
                      class="spinner-grow spinner-grow-sm mr-1"
                      role="status"
                      aria-hidden="true"
                    >
                    </span
                    >Loading...
                  </span>
                  <span v-if="!btnLoading" class="ti-check-box"></span>
                  <span v-if="!btnLoading"> Update Slider</span>
                </button>
              </div>

              <div class="form-group">
                <button
                  type="button"
                  class="btn btn-danger"
                  :disabled="btnLoading"
                  @click="cancel"
                >
                  <span class="ti-close"></span>
                  <span> Cancel </span>
                </button>
              </div>
            </div>
            <!-- End Buttons -->
          </form>
        </div>

        <Footer></Footer>
      </div>
    </main>
    <!-- End Main -->
  </div>
</template>

<script>
import Header from "../layouts/Header.vue";
import Navigation from "../layouts/Navigation";
import Footer from "../layouts/Footer.vue";
import { VueEditor } from "vue2-editor";
import iziToast from "izitoast";

export default {
  name: "Create",
  components: {
    Header,
    Navigation,
    Footer,
    VueEditor,
  },
  data() {
    return {
      auth: {
        access_token: "",
      },
      row: {
        status: 1,

        preview_image: "",
        image: "",

        preview_video: "",
        video: "",

        sort: 0,
        duration: 5,
        button: "",
        redirect: "",

        bgColor: "",
        lineColor: "",
        title: "",
        body: "",
      },

      btnLoading: false,
    };
  },
  mounted() {},
  computed: {},
  created() {
    // AccessToken & Role
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }

    this.fetchRow();
  },
  methods: {
    // fetch Row
    fetchRow() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/sliders/" + this.$route.params.id,
        method: "GET",
        data: {},
        params: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.row.status = res.data.row.status;
          this.row.sort = res.data.row.sort;
          this.row.duration = res.data.row.duration;
          this.row.button = res.data.row.button;
          this.row.redirect = res.data.row.redirect;
          this.row.lineColor = res.data.row.lineColor;

          if (res.data.row.mimType == "image") {
            this.row.preview_image = res.data.row.file;
            this.row.image = res.data.row.file;
          } else {
            this.row.preview_video = res.data.row.file;
            this.row.video = res.data.row.file;
          }

          this.row.bgColor = res.data.row.bgColor;
          this.row.lineColor = res.data.row.lineColor;
          this.row.title = res.data.row.title;
          this.row.body = res.data.row.body;
        })
        .catch((err) => {
          this.pgLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "Wow-man,",
            message: err.response ? err.response.data.message : "" + err,
          });
        })
        .finally(() => {});
    },

    // Add New
    editRow() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const config = { headers: { "Content-Type": "multipart/form-data" } };
      const options = {
        url: window.baseURL + "/sliders/" + this.$route.params.id,
        method: "PUT",
        data: {
          status: this.row.status,
          sort: this.row.sort,
          duration: this.row.duration,
          button: this.row.button,
          redirect: this.row.redirect,

          image: this.row.image,
          video: this.row.video,

          bgColor: this.row.bgColor,
          lineColor: this.row.lineColor,
          title: this.row.title,
          body: this.row.body,
        },
      };
      this.axios(options, config)
        .then(() => {
          this.btnLoading = false;
          iziToast.success({
            icon: "ti-check",
            title: "Great job,",
            message: "Item Updated Successfully.",
          });
          this.$router.push({ name: "sliders" });
        })
        .catch((err) => {
          this.btnLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "Wow-man,",
            message: err.response ? err.response.data.message : "" + err,
          });
        })
        .finally(() => {});
    },

    // Upload Featured image
    onImageChange(e) {
      const file = e.target.files[0];
      this.row.preview_image = URL.createObjectURL(file);
      this.createBase64Image(file);
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();
      reader.readAsDataURL(fileObject);
      reader.onload = (e) => {
        this.row.image = e.target.result;
      };
    },
    onVideoChange(e) {
      const file = e.target.files[0];
      this.row.preview_video = URL.createObjectURL(file);
      this.createBase64Video(file);
    },
    createBase64Video(fileObject) {
      const reader = new FileReader();
      reader.readAsDataURL(fileObject);
      reader.onload = (e) => {
        this.row.video = e.target.result;
      };
    },

    // active status
    onStatus() {
      if (this.row.status) this.row.status = 0;
      else this.row.status = 1;
    },

    // toggleCollapse
    collapseToggle(div) {
      let el = document.querySelector("span#iconToggle" + div);
      if (el.classList.contains("ti-angle-down")) {
        el.classList.remove("ti-angle-down");
        el.classList.add("ti-angle-up");
      } else {
        el.classList.remove("ti-angle-up");
        el.classList.add("ti-angle-down");
      }
    },

    // Cancel
    cancel() {
      if (confirm("Are You Sure?")) {
        this.$router.push({ name: "sliders" });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
